var _a, _b;
import { createTheme } from "@mui/material/styles";
var lens = "#444";
var laser = "#FF3158";
var mirror = "#DADADA";
var moonrock = "#F5F4F3";
var baseTheme = createTheme({});
export var Theme = createTheme({
    components: {
        MuiFormControl: {
            styleOverrides: {
                root: {
                    margin: "10px 0 20px",
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottom: "1px solid ".concat(mirror),
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "1px solid ".concat(mirror),
                    },
                    "&:after": {
                        borderBottom: "1px solid ".concat(lens),
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    zIndex: 100,
                },
                formControl: {
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    maxWidth: "100%",
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    lineHeight: "24px",
                    color: lens,
                    "&.Mui-focused": {
                        color: lens,
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    width: "auto",
                    transition: "background .15s linear, color .15s linear",
                    padding: "0 16px 0 16px",
                    height: "48px",
                    color: lens,
                    "-webkit-font-smoothing": "antialiased",
                    textRendering: "optimizeLegibility",
                    borderBottom: "1px solid ".concat(mirror),
                    "&:hover": {
                        backgroundColor: moonrock,
                    },
                    "&.Mui-selected": {
                        backgroundColor: moonrock,
                        color: laser,
                        "&:hover": {
                            backgroundColor: moonrock,
                        },
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    color: lens,
                },
                select: {
                    "&:focus": {
                        backgroundColor: "none",
                    },
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: (_a = {},
                    _a[baseTheme.breakpoints.up("sm")] = {
                        maxHeight: "calc(50vh - 32px)",
                    },
                    _a),
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: (_b = {},
                    _b[baseTheme.breakpoints.up("sm")] = {
                        maxHeight: "calc(50vh - 32px)",
                    },
                    _b),
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                input: {
                    padding: "0 !important",
                },
            },
        },
    },
});
